import {useEffect} from 'react';
import dayjs from 'dayjs';
import globalNavigation from '@/utils/global-navigation';
import {
  getHiddenPopupState,
  setHiddenPopupState,
} from '@/utils/main/my-plus/bottomBanner';

const COOKIE_KEY_HIDE_CONFETTI = 'chk_confetti';
const CONFETTI_DURATION_MS = 3000;

const Confetti = ({mainListInfo}) => {
  useEffect(() => {
    const {mainEffectAnimationResult, mainEffectAnimationData} = mainListInfo;
    if (mainEffectAnimationResult !== 1) {
      return;
    }

    const data = mainEffectAnimationData?.[0];
    if (!data) {
      return;
    }

    const now = new Date();
    if (
      !(
        (!data.startDate || new Date(data.startDate) <= now) &&
        (!data.endDate || now <= new Date(data.endDate))
      )
    ) {
      // 노출 기한 벗어남
      return;
    }

    // 컨페티는 최초 1회 노출
    const showConfetti = () => {
      const hiddenStates = getHiddenPopupState(COOKIE_KEY_HIDE_CONFETTI);
      if (hiddenStates[data.bannerName] === 'y') {
        return;
      }

      const days = dayjs(data.endDate).diff(dayjs(), 'day');
      setHiddenPopupState(
        COOKIE_KEY_HIDE_CONFETTI,
        data.bannerName,
        days,
        true,
      );
      globalNavigation.fireConfetti(CONFETTI_DURATION_MS);
    };

    showConfetti();
  }, [mainListInfo]);

  return null;
};

export default Confetti;
